// extracted by mini-css-extract-plugin
export var container = "_cr-0";
export var containerTopRight = "_cr-1";